import moment from "moment";
import React, {Component, Fragment} from "react";
import {withTranslation} from "react-i18next";
import {MAX_MONTH_RANGE} from "../../constant";
import CalendarDateRangePicker from "../common/CalendarDateRangePicker";

const DATE_FORMAT = "dd/MM/yyyy";

const initialState = {
  branchId: "",
  historyStartDate: moment().subtract(1, "day").toDate().setMilliseconds(0),
  historyEndDate: moment().toDate(),
  maxHistoryDate: moment().toDate(),
  showError: false,
  errorMsg: "",
  branchList: "",
};

class KycTierPricingHistorySearchForm extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  monthRangeIsMoreThanMaxMonthRange = (from, to) => {
    const monthDiff = to.diff(from, "months", true);
    return monthDiff > MAX_MONTH_RANGE;
  };

  onChangeInputHandler = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  onClearHandler = (event) => {
    event.preventDefault();
    const { onClear } = this.props;
    this.setState(initialState);

    if (onClear) {
      onClear();
    }
  };

  onSubmitHandler = (event) => {
    event.preventDefault();

    const from = moment(this.state.historyStartDate);
    const to = moment(this.state.historyEndDate);

    if (this.monthRangeIsMoreThanMaxMonthRange(from, to)) {
      this.setState({
        showError: true,
        errorMsg:
          "Date range must not be more than " + MAX_MONTH_RANGE + " months",
      });
    } else if (!this.state.showError) {
      const params = Object.assign({}, this.state);
      this.props.onSubmit(params);
    }
  };

  onChangeStartDate = (historyStartDate) => {
    let showError = false;
    let errorMsg = "";

    if (!historyStartDate) {
      showError = true;
      errorMsg = "History start date is required";
    } else {
      let from = moment(historyStartDate);
      let to = moment(this.state.historyEndDate);

      if (from.isAfter(to)) {
        showError = true;
        errorMsg = "End date must not be less than start date";
      } else {
        if (this.monthRangeIsMoreThanMaxMonthRange(from, to)) {
          showError = true;
          errorMsg =
            "Date range must not be more than " + MAX_MONTH_RANGE + " months";
        }
      }
    }

    this.setState({
      historyStartDate: historyStartDate,
      showError: showError,
      errorMsg: errorMsg,
    });
  };

  onChangeEndDate = (historyEndDate) => {
    let showError = false;
    let errorMsg = "";

    if (!historyEndDate) {
      showError = true;
      errorMsg = "History end date is required";
    } else {
      let from = moment(this.state.historyStartDate);
      let to = moment(historyEndDate);

      if (to.isBefore(from)) {
        showError = true;
        errorMsg = "Start date must not be more than end date";
      } else {
        if (this.monthRangeIsMoreThanMaxMonthRange(from, to)) {
          showError = true;
          errorMsg =
            "Date range must not be more than " + MAX_MONTH_RANGE + " months";
        }
      }
    }

    this.setState({
      historyEndDate: historyEndDate,
      showError: showError,
      errorMsg: errorMsg,
    });
  };

  render() {
    const { disable } = this.props;
    const { errorMsg, showError } = this.state;
    return (
      <Fragment>
        <form className="card-body form-search">
          <div className="row">
            <div className="offset-sm-2 col-sm-4 row">
              <label className="col-form-label col-sm-5 text-lg-right">
                Branch
              </label>
              <div className="col-sm-7 p-0">
                <input
                  type="text"
                  className="form-control"
                  name="branchId"
                  value={this.state.branchId}
                  onChange={this.onChangeInputHandler}
                />
                <label hidden={!this.state.showErrorBranch}>
                  <span style={{ color: "red" }}>
                    {this.state.errorMsgBranch}
                  </span>
                </label>
              </div>
            </div>
          </div>

          <div className="row mt-2">
            <CalendarDateRangePicker
              onChangeStartDate={this.onChangeStartDate}
              onChangeEndDate={this.onChangeEndDate}
              maxStartDate={this.state.maxHistoryDate}
              maxEndDate={this.state.maxHistoryDate}
              StartDateTextShow={"From Date"}
              defaultStartDate={this.state.historyStartDate}
              EndDateTextShow={"To Date"}
              defaultEndDate={this.state.historyEndDate}
              dateFormat={DATE_FORMAT}
              errorShown={showError}
              errorMessage={errorMsg}
            />
          </div>
          <div className="row mt-2 justify-content-center">
            <div className="col-md-12 text-center">
              <button
                data-testid="tier-button-search"
                name="submit"
                onClick={this.onSubmitHandler}
                className="btn btn-warning"
                disabled={disable}
              >
                <i className="fa fa-search" /> Search
              </button>
              <button
                data-testid="tier-button-clear"
                className="btn btn-secondary ml-2"
                onClick={this.onClearHandler}
                disabled={disable}
                name="clear"
                type="button"
              >
                <i className="fa fa-refresh" /> Clear
              </button>
            </div>
          </div>
        </form>
      </Fragment>
    );
  }
}
export default withTranslation()(KycTierPricingHistorySearchForm);
